import { brand } from '@/config/brand';
import { useT } from '@/i18n';
import { cn } from '@/lib/cn';

/**
 * Eigenes Logo: ein Schild als Rahmen fuer einen Tunnel, durch den ein Paket
 * laeuft. Rein als SVG umgesetzt, damit es in jeder Groesse scharf bleibt und
 * die Akzentfarbe aus den Design-Tokens uebernimmt.
 */
export function BrandMark({ size = 34, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-[10px] bg-gradient-to-br from-acc to-acc-2',
        'shadow-[0_6px_16px_-4px_var(--acc-soft)]',
        className,
      )}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg
        width={size * 0.58}
        height={size * 0.58}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Schild */}
        <path d="M12 2.5 4.5 6v6c0 4.4 3.1 8.1 7.5 9.5 4.4-1.4 7.5-5.1 7.5-9.5V6z" />
        {/* Tunneloeffnung */}
        <path d="M9 14.5v-3a3 3 0 0 1 6 0v3" />
        {/* Paket im Tunnel */}
        <circle cx="12" cy="14.6" r="1.15" fill="#fff" stroke="none" />
      </svg>
    </span>
  );
}

/** Logo mit Schriftzug - fuer Seitenleiste und Anmeldung. */
export function BrandLogo({
  size = 34,
  showText = true,
  showTagline = false,
  className,
}: {
  size?: number;
  showText?: boolean;
  showTagline?: boolean;
  className?: string;
}) {
  const t = useT();
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <BrandMark size={size} />
      {showText && (
        <span className="leading-tight">
          <span className="block text-[17px] font-extrabold text-t0">
            {brand.shortName}
            <span className="text-acc">.</span>
          </span>
          {showTagline && <span className="block text-[11px] text-t2">{t('brand.tagline')}</span>}
        </span>
      )}
    </span>
  );
}
